module.exports = __webpack_public_path__ + "img/customer.a74f74fb.png";